// @convertkit plugins
import { Products } from "./products"
import { CountdownTimer } from "./countdown-timer"

export const Plugins = () => [Products(), CountdownTimer()]
